"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lightbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactImageLightbox = _interopRequireDefault(require("react-image-lightbox"));
var _useEscapeManager = require("../../lib/hooks/useEscapeManager");
var _Icons = require("../Icons");
require("react-image-lightbox/style.css");
var _LightboxModule = _interopRequireDefault(require("./Lightbox.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Lightbox = _ref => {
  var items = _ref.items,
    _ref$startingIndex = _ref.startingIndex,
    startingIndex = _ref$startingIndex === void 0 ? 0 : _ref$startingIndex,
    onClose = _ref.onClose,
    provider = _ref.provider;
  var _useState = (0, _react.useState)(startingIndex),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCopied = _useState4[0],
    setIsCopied = _useState4[1];
  var escapeManager = (0, _useEscapeManager.useEscapeManager)();
  var currentItem = items[index];
  var isCurrentItemGif = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.mimetype) === 'image/gif';
  (0, _react.useEffect)(() => {
    escapeManager === null || escapeManager === void 0 || escapeManager.register(onClose);
    return () => escapeManager === null || escapeManager === void 0 ? void 0 : escapeManager.unregister();
  }, [escapeManager, onClose]);
  var copyImage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      var currentItem = items[index];
      if (!(currentItem !== null && currentItem !== void 0 && currentItem.url)) return;
      try {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        yield new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = currentItem.url;
        });
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Failed to get canvas context');
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(function* (blob) {
            if (blob) {
              try {
                yield navigator.clipboard.write([new ClipboardItem({
                  'image/png': blob
                })]);
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 2000);
              } catch (clipboardError) {
                console.error('Failed to write to clipboard:', clipboardError);
              }
            }
          });
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }(), 'image/png');
      } catch (err) {
        console.error('Failed to copy image:', err);
      }
    });
    return function copyImage() {
      return _ref2.apply(this, arguments);
    };
  }();
  var downloadImage = () => {
    var currentItem = items[index];
    if (!currentItem || !currentItem.url) return;
    var link = document.createElement('a');
    link.href = currentItem.url;
    link.download = currentItem.name || 'image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  var getPreviousItemIndex = currentIndex => {
    return (currentIndex + items.length - 1) % items.length;
  };
  var getNextItemIndex = currentIndex => {
    return (currentIndex + items.length + 1) % items.length;
  };
  var processedItems = items.map(media => {
    if (media.type === 'image') {
      var options = provider.fitWithinBox(media);
      return provider.getSource({
        src: media.url,
        options
      });
    }
    return media.url;
  });
  var activeItem = processedItems[index];
  var previousItem = processedItems.length > 1 ? processedItems[getPreviousItemIndex(index)] : null;
  var nextItem = processedItems.length > 1 ? processedItems[getNextItemIndex(index)] : null;
  return /*#__PURE__*/_react.default.createElement(_reactImageLightbox.default, {
    mainSrc: activeItem,
    nextSrc: nextItem,
    prevSrc: previousItem,
    animationOnKeyInput: true,
    enableZoom: false,
    wrapperClassName: _LightboxModule.default.Lightbox,
    onCloseRequest: onClose,
    onMovePrevRequest: () => setIndex(getPreviousItemIndex(index)),
    onMoveNextRequest: () => setIndex(getNextItemIndex(index)),
    toolbarButtons: [!isCurrentItemGif && /*#__PURE__*/_react.default.createElement("button", {
      key: "copy",
      onClick: copyImage,
      className: _LightboxModule.default.DownloadButton,
      "aria-label": "Copy image"
    }, /*#__PURE__*/_react.default.createElement(_Icons.IconCopy2, {
      size: 28,
      isFilled: isCopied
    })), !isCurrentItemGif && /*#__PURE__*/_react.default.createElement("button", {
      key: "download",
      onClick: downloadImage,
      className: _LightboxModule.default.DownloadButton,
      "aria-label": "Download image"
    }, /*#__PURE__*/_react.default.createElement(_Icons.IconDownload2, {
      size: 28
    }))].filter(Boolean)
  });
};
exports.Lightbox = Lightbox;
//# sourceMappingURL=Lightbox.js.map